<template>
  <div
    v-if="this.$store.getters['authorization/acl'].hasPermission('dashboard_access')"
    class="PlatformDashboardView"
  >
    <DashboardProjectList :project-list="projectList"
                          @changeProject="handleChangeProject"
    />
    <DashbordSummaryLayout v-if="!this.$store.getters['authorization/acl'].hasPermission('self_only_display')">
      <template #connections>
        <DashboardSummaryForConnections
          :connection-list="filteredConnectionList"
          :connection-type-list="connectionTypeListGroupedByType"
        />
      </template>
      <template #agents>
        <DashboardSummaryForAgents :agent-list="filteredAgentsByProject" />
      </template>
    </DashbordSummaryLayout>
    <DashboardList>
      <!-- zakładki -->
      <template #connections>
        <SortingAndFiltering
          :all-connections="allConnections"
          :agents-belongs-to-user-list="agentsBelongsToUserList"
          :selected-project="selectedProject"
          @setFilteredConnectionList="setFilteredConnectionList"
        />
        <DashboardListForConnections
          :connection-list="filteredConnectionList"
          :connection-type-list="connectionTypeList"
          :projects="projectsUuids"
          :project-list="projectList"
          :agent-list="filteredAgentsByProject"
        />
      </template>
      <template #agents>
        <DashboardListForAgents :agent-list="filteredAgentsByProject"
                                :projects="projectsUuids"
        />
      </template>
    </DashboardList>
  </div>
</template>

<script>

import _groupBy from 'lodash.groupby';
import DashboardProjectList from '@/components/Dashboard/DashboardProjectList';
import DashboardList from '@/components/Dashboard/DashboardList';
import DashboardListForConnections
  from '@/components/Dashboard/DashboardList/DashboardListForConnections';
import DashboardListForAgents from '@/components/Dashboard/DashboardList/DashboardListForAgents';
import DashbordSummaryLayout from '@/components/Dashboard/DashbordSummaryLayout';
import DashboardSummaryForConnections
  from '@/components/Dashboard/DashbordSummaryLayout/DashboardSummaryForConnections';
import DashboardSummaryForAgents
  from '@/components/Dashboard/DashbordSummaryLayout/DashboardSummaryForAgents';
import SortingAndFiltering from '../components/Dashboard/DashboardList/DashboardListForConnections/SortingAndFiltering';

export default {
  name: 'PlatformDashboard',
  components: {
    DashboardProjectList,
    DashboardList,
    DashboardListForConnections,
    DashboardListForAgents,
    DashbordSummaryLayout,
    DashboardSummaryForConnections,
    DashboardSummaryForAgents,
    SortingAndFiltering,
  },
  data() {
    return {
      selectedProject: 'all',
      isAgentsLoading: true,
      filteredConnectionList: [],
    };
  },

  computed: {
    filteredAgentsByProject() {
      if (this.selectedProject === 'all') {
        return this.allAgents;
      }
      return this.allAgents.filter(item => item.project_id === this.selectedProject);
    },
    allConnections() {
      return this.$store.getters['dashboard/liveList'];
    },
    allAgents() {
      return this.$store.getters['user/agent/agentsList'].records;
    },
    userData() {
      return this.$store.getters['authorization/user'];
    },
    projectList() {
      const projects = this.$store.getters['client/projects/list']?.records;
      if (this.$store.getters['authorization/acl'].hasPermission('dashboard_projects_connection_list_display')) {
        return projects.filter((project) => {
          return this.allConnections.some(connection => connection._project_id === project.id);
        });
      } else {
        return projects;
      }
    },
    projectsUuids() {
      const projects = this.$store.getters['client/projects/list']?.records;
      const projectsUuids = projects.map(project => project.uuid);
      return projectsUuids;
    },
    connectionTypeListGroupedByType() {
      return _groupBy(this.$store.getters['connections/types/list'].records, 'type');
    },
    connectionTypeList() {
      return this.$store.getters['connections/types/list'].records;
    },
    currentElementsMenu() {
      return this.$store.getters['dashboard/elementsIds'];
    },
    agentsBelongsToUserList() {
      return this.$store.getters['user/agent/agentsBelongsToUserlist'].records;
    },
  },

  async created() {
    this.$store.dispatch('connections/types/getTypeList');
    this.$store.dispatch('dashboard/getCurrentElementsMenu');
    await this.$store.dispatch('client/projects/getList', this.userData.client.uuid);
    await this.$store.dispatch('dashboard/getLiveList');
    this.$store.dispatch('user/agent/getAgentsList', this.projectsUuids);
    this.$store.dispatch('sms/getSmsHeadersList');
    this.filteredConnectionList = this.allConnections;
  },

  methods: {
    handleChangeProject(selectedProject) {
      this.selectedProject = selectedProject;
    },
    setFilteredConnectionList(list) {
      this.filteredConnectionList = list;
    },
  },
};
</script>

<style lang="sass" scoped>
.PlatformDashboardView
  margin: 20px
</style>
